export default "__VITE_ASSET__D6p0p_P3__"